import React from 'react';
import styles from './StepForm.module.scss';

export interface Props
  extends Partial<React.AnchorHTMLAttributes<HTMLAnchorElement>> {}

export default function StepFormLink(props: Props) {
  return <a {...props} className={styles.StepFormLink} />;
}
